/**
 * 人事行政總處公告的放假日。補假一併標出，方便對照要不要從可排班日拿掉。
 * 只收已公告的年份；沒有資料的日期不顯示假日名。
 */
const HOLIDAYS = {
    '2025-01-01': '元旦',
    '2025-01-28': '除夕',
    '2025-01-29': '春節',
    '2025-01-30': '春節',
    '2025-01-31': '春節',
    '2025-02-28': '和平紀念日',
    '2025-04-04': '兒童節、清明',
    '2025-05-01': '勞動節',
    '2025-05-31': '端午節',
    '2025-10-06': '中秋節',
    '2025-10-10': '國慶日',

    '2026-01-01': '元旦',
    '2026-02-15': '小年夜',
    '2026-02-16': '除夕',
    '2026-02-17': '春節',
    '2026-02-18': '春節',
    '2026-02-19': '春節',
    '2026-02-20': '小年夜補假',
    '2026-02-27': '和平紀念日補假',
    '2026-02-28': '和平紀念日',
    '2026-04-03': '兒童節補假',
    '2026-04-04': '兒童節',
    '2026-04-05': '清明節',
    '2026-04-06': '清明補假',
    '2026-05-01': '勞動節',
    '2026-06-19': '端午節',
    '2026-09-25': '中秋節',
    '2026-09-28': '教師節',
    '2026-10-09': '國慶補假',
    '2026-10-10': '國慶日',
    '2026-10-25': '光復節',
    '2026-10-26': '光復補假',
    '2026-12-25': '行憲紀念日',

    '2027-01-01': '元旦',
    '2027-02-04': '小年夜',
    '2027-02-05': '除夕',
    '2027-02-06': '春節',
    '2027-02-07': '春節',
    '2027-02-08': '春節',
    '2027-02-09': '春節補假',
    '2027-02-10': '春節補假',
    '2027-02-28': '和平紀念日',
    '2027-03-01': '和平紀念日補假',
    '2027-04-04': '兒童節',
    '2027-04-05': '清明節',
    '2027-04-06': '清明補假',
    '2027-04-30': '勞動節補假',
    '2027-05-01': '勞動節',
    '2027-06-09': '端午節',
    '2027-09-15': '中秋節',
    '2027-09-28': '教師節',
    '2027-10-10': '國慶日',
    '2027-10-11': '國慶補假',
    '2027-10-25': '光復節',
    '2027-12-24': '行憲紀念日補假',
    '2027-12-25': '行憲紀念日',
    '2027-12-31': '元旦補假',

    '2028-01-01': '元旦',
    '2028-02-28': '和平紀念日',
    '2028-04-04': '兒童節',
    '2028-05-01': '勞動節',
    '2028-09-28': '教師節',
    '2028-10-10': '國慶日',
    '2028-10-25': '光復節',
    '2028-12-25': '行憲紀念日'
};

export function taiwanHolidayName(isoDate) {
    return HOLIDAYS[isoDate] || '';
}
